
import { commitMutation, graphql } from "react-relay";
import environment from "../AuthEnv";
import { GC_AUTH_TOKEN, GC_USER_ID, GRAPHQL_PATH } from "../constants";

const mutation = graphql`
	mutation DeleteSubscriptionMutation($subId: ID) {
		deleteSubscription(subId: $subId) {
			ok		
		}
	}
`;

// optimisticResponse implementation

const optimisticResponse = {
	deleteSubscription: {
		ok: true	
	}
} 

export default (subId, callback) => {
	const variables = {
			subId: subId,
	};

	commitMutation(environment, {
		mutation,
		optimisticResponse,
		optimisticUpdater: proxyStore => {
			// const subId = proxyStore.get('subId');
			// console.log("Subscription Id: " + subId);
		},
		
		variables,
		onCompleted: (response, errors) => {
			if (response.deleteSubscription != null) {
				callback();
			} else {
				console.log("Unable to delete feed!");
			}
		},
		onError: err => console.error(err)
	});
};
